import { io } from "socket.io-client";

// Replace with your backend server URL
const SOCKET_URL = "https://apisavani.sparkflows.in";

const socket = io(SOCKET_URL, {
  autoConnect: false, // Prevent auto connection, connect manually when needed
  reconnection: true, // Auto-reconnect when the connection drops
});

console.log("socket connected!!!");

export default socket;
